module.exports = "/images/iconCountry.svg?f57bbbeaa487e255107907754e58bb22";